import { useTranslation } from 'react-i18next'

import { AdvancedDomainCheck } from '../utils/getGroupedFraudChecks'
import { AutoDomainFraudChecksAlert } from '../autoDomainFraudChecksAlert/AutoDomainFraudChecksAlert'

import { getProperHref } from '@percent/admin-dashboard/common/utility/getProperHref'
import { CardContent, CardDashboard } from '@percent/lemonade'
import styles from './FraudCheckDomainAnalysis.module.scss'
import { DomainAnalysisItemProps, DomainAnalysisProps } from './FraudCheckDomainAnalysis.types'
import { FraudCheckDomainCheckInfo } from './FraudCheckDomainCheckInfo'

const advancedChecksSortOrder = ['who_is_check', 'geolocation_check'] as const
const sortAdvancedChecks = (a: AdvancedDomainCheck, b: AdvancedDomainCheck) =>
  advancedChecksSortOrder.indexOf(a.checkName) - advancedChecksSortOrder.indexOf(b.checkName)

function FraudCheckDomainAnalysisItem({
  index,
  name,
  failedAutoChecks,
  allAutoChecks,
  shouldHideAlerts
}: DomainAnalysisItemProps) {
  const { t } = useTranslation()

  const sortedAdvancedChecks = allAutoChecks.advanced.sort(sortAdvancedChecks)

  return (
    <div className={styles.container}>
      <CardDashboard title={t('autoFraudChecks.domainAnalysis.title', { index })}>
        {!shouldHideAlerts && <AutoDomainFraudChecksAlert failedAutoChecks={failedAutoChecks} />}
        <CardContent title={t('table.website')}>
          <a href={getProperHref(name)} target="_blank" rel="noopener noreferrer" className={styles.websiteLink}>
            {name}
          </a>
        </CardContent>
        {sortedAdvancedChecks.map(check => (
          <FraudCheckDomainCheckInfo key={check.checkName} {...check} />
        ))}
      </CardDashboard>
    </div>
  )
}

export function FraudCheckDomainAnalysis({
  groupedFraudChecks,
  isAutoFraudCheckEnabled,
  shouldHideAlerts = false
}: DomainAnalysisProps) {
  const domainAnalysisChecks = groupedFraudChecks?.domains.map(domain => ({
    name: domain.name,
    failedAutoChecks: domain.failedChecks,
    allAutoChecks: domain.fraudChecks
  }))

  const shouldShowSeparateDomainAnalysis =
    isAutoFraudCheckEnabled && !!domainAnalysisChecks && domainAnalysisChecks.length > 0

  if (!shouldShowSeparateDomainAnalysis) return null

  return (
    <>
      {domainAnalysisChecks.map((check, index) => (
        <FraudCheckDomainAnalysisItem
          key={check.name}
          index={index + 1}
          {...check}
          shouldHideAlerts={shouldHideAlerts}
        />
      ))}
    </>
  )
}
